import type { ConsolaInstance } from 'consola'

export function useLogger(): ConsolaInstance {
  return useNuxtApp().$logger
}
